import script from "./SimpleProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleProfile.vue?vue&type=script&setup=true&lang=js"

import "./SimpleProfile.vue?vue&type=style&index=0&id=be35b3aa&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be35b3aa"]])

export default __exports__